module.exports = __webpack_public_path__ + "img/join_us_02.950828c3.jpg";